export default __webpack_public_path__ + "static/media/default-avatar.bfa32228.svg";